import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { BookingsSection } from '@components/Home/BookingsSection';
import { DEFAULT_NUMBER_OF_BOOKINGS_SHOWN } from '@components/Home/constants';
import { NoddiCircularLoaderWithTrans } from '@components/Loading/NoddiCircularLoaderWithTrans';
import { BookingRecordListForCustomer, BookingStatus } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { PaginatedResponse } from 'noddi-types';
import { useState } from 'react';
import { useBookingUserGroupId } from '../../../hooks/useBookingUserGroupId';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';

const activeStatuses = new Set([BookingStatus.CONFIRMED, BookingStatus.ASSIGNED_TO_ROUTE]);

function filterActiveBookings(data: PaginatedResponse<BookingRecordListForCustomer[]>) {
  const filtered = data.results.filter((booking) => activeStatuses.has(booking.status.value));
  return { ...data, results: filtered, count: filtered.length };
}

export const UpcomingBookings = ({ userGroupId }: { userGroupId: number }) => {
  const [showAllBookings, setShowAllBookings] = useState(false);
  const { currentBrand } = useCurrentBrand();
  const { bookingUserGroupId, isReady, error: bookingUserGroupError } = useBookingUserGroupId(userGroupId);

  const { isPending, data, error } = noddiAsync.useGet({
    type: URLKeys.getPaginatedBookingsForCustomer,
    input: {
      userGroupId: bookingUserGroupId,
      isUpcoming: true,
      pageSize: showAllBookings ? 1000 : DEFAULT_NUMBER_OF_BOOKINGS_SHOWN,
      pageIndex: 0,
      brandDomains: [currentBrand]
    },
    queryConfig: {
      enabled: isReady,
      select: filterActiveBookings
    }
  });

  if (bookingUserGroupError) {
    return <ApiErrorPageWithTrans error={bookingUserGroupError} />;
  }
  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  if (!isReady || isPending) {
    return <NoddiCircularLoaderWithTrans />;
  }

  return (
    <BookingsSection
      bookingsPaginated={data}
      isUpcomingBooking
      showAllBookings={showAllBookings}
      setShowAllBookings={setShowAllBookings}
    />
  );
};
